import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NewpasswordComponent } from '../newpassword/newpassword.component';

const routes: Routes = [
  { path: '', component: NewpasswordComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewpasswordRoutingModule { }
